import api from './api';

export type PaymentProvider = 'apple' | 'google' | 'wayforpay';

// Кожен провайдер повертає свій набір полів (config — не уніфікований по
// формі навмисно, різні системи технічно різні) — див.
// api/src/modules/client-payments/apple/apple-iap.service.ts,
// google/google-iap.service.ts, wayforpay/wayforpay.service.ts,
// метод getDiagnosticsConfig() кожного.
export interface AppleRootCertificateInfo {
  filename: string;
  expiresAt: string;
}

export interface AppleDiagnosticsConfig {
  bundleId: string;
  hasKeyId: boolean;
  hasIssuerId: boolean;
  hasSigningKey: boolean;
  hasAppAppleId: boolean;
  rootCertificatesCount: number;
  rootCertificates: AppleRootCertificateInfo[];
  sandboxVerifierReady: boolean;
  productionVerifierReady: boolean;
}

export interface GoogleDiagnosticsConfig {
  packageName: string;
  androidPublisherConfigured: boolean;
  serviceAccountEmail: string | null;
  rtdnConfigured: boolean;
}

export interface WayForPayDiagnosticsConfig {
  merchantAccount: string | null;
  hasSecretKey: boolean;
  domainName: string;
  apiUrl: string;
  sandboxMode: boolean;
}

export type DiagnosticsConfig = AppleDiagnosticsConfig | GoogleDiagnosticsConfig | WayForPayDiagnosticsConfig;

export interface RecentActivitySummary {
  provider: string;
  lastSuccessAt: string | null;
  lastFailureAt: string | null;
  lastFailureReason: string | null;
  last24h: { success: number; failure: number };
  last7d: { success: number; failure: number };
}

export interface PaymentDiagnosticsResponse {
  provider: PaymentProvider;
  config: DiagnosticsConfig;
  recentActivity: RecentActivitySummary;
}

export interface LiveCheckResponse {
  provider: PaymentProvider;
  ok: boolean;
  detail: string;
  environment?: 'production' | 'sandbox';
  productIds?: string[];
}

/**
 * Дев-діагностика Apple/Google/WayForPay для веб-кабінету розробника.
 * Бекенд: api/src/modules/payment-diagnostics/payment-diagnostics.controller.ts
 * (НЕ самозагортає відповідь у {success,...} — читаємо через `.data.data`,
 * див. коментар у native-iap-admin.service.ts про той самий нюанс).
 */
export const paymentDiagnosticsService = {
  getDiagnostics: async (provider: PaymentProvider): Promise<PaymentDiagnosticsResponse> => {
    const res = await api.get('/admin/payment-diagnostics', { params: { provider } });
    return res.data.data as PaymentDiagnosticsResponse;
  },

  runLiveCheck: async (provider: PaymentProvider): Promise<LiveCheckResponse> => {
    const res = await api.post('/admin/payment-diagnostics/live-check', null, { params: { provider } });
    return res.data.data as LiveCheckResponse;
  },
};
